import { TokenListProvider, TokenInfo } from '@solana/spl-token-registry';

const STATIC_URL = process.env.REACT_APP_STATIC_URL;

export function shortenAddress(address: string, startLength?: number, endLength?: number) {
    if (!startLength) startLength = 4;
    if (!endLength) endLength = 4;

    return address.substring(0, startLength) + '..' + address.substring(address.length - endLength, address.length);
}

export function encodeFileBase64(file: File | Blob): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(reader.result as string);
        };

        reader.readAsDataURL(file);
        reader.onerror = reject;
    });
}

export function getProfilePicture(address?: string) {
    let fileName = address ?? 'default';
    let fileType = 'jpg';

    if (fileName.length === 0) fileName = 'default';
    return `${STATIC_URL}/users/${fileName}.${fileType}`;
}

export function getGameAssetsUrl(id: number) {
    return `${STATIC_URL}/games/${id}`;
}

export function getGameAssetsUrl2(name?: string) {
    let fileName = name ?? 'default';
    if (fileName.length === 0) fileName = 'default';
    return `${STATIC_URL}/games/${fileName}`;
}

export function getPublisherLogo(name?: string) {
    let fileName = name ?? 'default';
    if (fileName.length === 0) fileName = 'default';
    fileName = fileName.toLowerCase().replace(/ /g, '-');
    return `${STATIC_URL}/publishers/${fileName}.png`;
}

export function formatDescription(description?: string) {
    if (!description) return description;

    // Add <br /> for new lines
    description = description.replace(/(?:\\r\\n|\r\n)/g, '<br /><br />');
    description = description.replace(/(?:\\r|\\n|\r|\n)/g, '<br />');

    // Replace links with anchor tags
    description = description.replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank">$1</a>');

    // Replace bbcode with html
    description = description.replace(/\[h([0-5])\](.*?)\[\/h([0-5])\]/g, '<h$1>$2</h$3>');
    description = description.replace(/\[b\](.*?)\[\/b\]/g, '<strong>$1</strong>');
    description = description.replace(/\[i\](.*?)\[\/i\]/g, '<em>$1</em>');
    description = description.replace(/\[u\](.*?)\[\/u\]/g, '<u>$1</u>');
    description = description.replace(/\[s\](.*?)\[\/s\]/g, '<s>$1</s>');
    description = description.replace(/\[img\](.*?)\[\/img\]/g, '<img src="$1" />');
    description = description.replace(/\[url\](.*?)\[\/url\]/g, '<a href="$1" target="_blank">$1</a>');
    description = description.replace(/\[url=(.*?)\](.*?)\[\/url\]/g, '<a href="$1" target="_blank">$2</a>');
    description = description.replace(/\[color=(.*?)\](.*?)\[\/color\]/g, '<span style="color: $1">$2</span>');
    description = description.replace(/\[size=(.*?)\](.*?)\[\/size\]/g, '<span style="font-size: $1px">$2</span>');
    description = description.replace(/\[center\](.*?)\[\/center\]/g, '<div style="text-align: center">$1</div>');
    description = description.replace(/\[left\](.*?)\[\/left\]/g, '<div style="text-align: left">$1</div>');
    description = description.replace(/\[right\](.*?)\[\/right\]/g, '<div style="text-align: right">$1</div>');
    description = description.replace(/\[justify\](.*?)\[\/justify\]/g, '<div style="text-align: justify">$1</div>');
    description = description.replace(/\[quote\](.*?)\[\/quote\]/g, '<blockquote>$1</blockquote>');
    description = description.replace(/\[quote=(.*?)\](.*?)\[\/quote\]/g, '<blockquote><strong>$1</strong><br />$2</blockquote>');
    description = description.replace(/\[code\](.*?)\[\/code\]/g, '<pre>$1</pre>');
    description = description.replace(/\[code=(.*?)\](.*?)\[\/code\]/g, '<pre class="$1">$2</pre>');

    return description;
}

export function formatNumber(input: string | number) {
    let num = Number(input);
    if (num >= 1000 && num < 1000000) {
        return (num / 1000).toFixed(2) + "K";
    } else if (num >= 1000000 && num < 1000000000) {
        return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000000000 && num < 1000000000000) {
        return (num / 1000000000).toFixed(2) + "B";
    } else if (num >= 1000000000000) {
        return (num / 1000000000000).toFixed(2) + "T";
    }
    return num.toFixed(2);
}

export const getTokenIcon = async (token: Token) => {
    return getTokenIcons([token]).then((tokenMap) => tokenMap.get(token.address));
}

export const getTokenIcons = async (tokens: Token[]) => {
    let tokenMap = new Map<string, TokenInfo>();
    let tokenProvider = await new TokenListProvider().resolve();
    const tokenList = tokenProvider.filterByClusterSlug('mainnet-beta').getList();
    tokens.forEach(tokenInfo => {
        const token = tokenList.find((token) => token.address === tokenInfo.address);
        if (token) tokenMap.set(token.address, token);
    });

    return tokenMap;
}